import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { ClaimList, ClaimListV2 } from "../../../types/claimList.types";
import { EOBDetails } from "../../../types/EOBDetails.types";
import { devServerUrl, headers, MEMBER_ENV } from "../../../config/config";

import axios from "axios";
import { prod_url, prod_port, port, version } from "../../../config/config";
import { Endpoint, Params, Payload, Headers } from "../../../types/api/api.types";

import { StatusCodes } from "http-status-codes";
import { request } from "../api";

const get = async (
	endpoint: Endpoint,
	headers?: Headers,
	params: Params = {},
	_port: number | undefined = undefined
) => {
	try {
		const newPort = _port ? _port : port;
		const url =
			MEMBER_ENV == "PROD"
				? `${prod_url}:${prod_port}`
				: MEMBER_ENV == "DEV"
				? devServerUrl
				: MEMBER_ENV == "LOCAL"
				? devServerUrl
				: devServerUrl;
		const response = await axios.get(`${url}/api/${version}/${endpoint}`, {
			headers,
			params
		});
		const { status } = response;
		if (status === 200) {
			return response;
		}
	} catch (err) {
		// console.log("err", err);
		// alert(err);
	}
};

const { Bearer } = AUTHORIZATION;
const initialRoute = "claims";

type EOBDetailsParams = {
	claim_pre: number;
	claim_number: number;
	claim_suffix: number;
	type: string;
};

export type ClaimListQuery = {
	dependent_number: number;
};

export const getClaimList = async (claimListQuery: ClaimListQuery): Promise<ClaimList> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/claim/employee`;
		const response = await get(
			endpoint,
			{
				Authorization: `${Bearer} ${token}`
			},
			claimListQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return {
					currentClaims: result.currentClaims.rows,
					historyClaims: result.historyClaims.rows
				};
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};
export const getClaimListV2 = async (claimListQuery: { SSN: string; group_number: number }): Promise<any> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/claim-status-admin-v2`;

		const response = await get(
			endpoint,
			{
				Authorization: `${Bearer} ${token}`
			},
			claimListQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return {
					claimResult: response.data.claimResult,
					memberResult: response.data.memberResult
				};
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getEOBDetails = async (params: EOBDetailsParams): Promise<EOBDetails> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/claim/employee/EOB`;
		const response = await get(
			endpoint,
			{
				Authorization: `${Bearer} ${token}`
			},
			params
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getEOBDetailsV2 = async (params: any) => {
	try {
		const endpoint = `${initialRoute}/eob-details`;
		const response = await get(
			endpoint,
			{
				...headers
			},
			params
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getClaimStatusDetails = async (
	SSN: string,
	date_of_birth: string,
	tax_id: string,
	date_of_service: string
) => {
	try {
		const endpoint = `claims/claim-status?SSN=${SSN}&date_of_birth=${date_of_birth}&tax_id=${tax_id}&date_of_service=${date_of_service}`;
		// const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers
			// [Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { memberResult, claimResult }
				} = response;
				return { memberResult, claimResult };
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			// // console.log("=====>SSN", SSN);
			// alert(`DOB is ${date_of_birth} and ssn is ${SSN}`);
			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;
			alert(message);
		} else {
			throw error;
		}
	}
};

export const getEOBDetailsV3 = async (claim_number: string, claim_prefix: string, claim_suffix: string) => {
	try {
		const endpoint = `claims/eob-details-v3?claim_number=${claim_number}&claim_prefix=${claim_prefix}&claim_suffix=${claim_suffix}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,

			Authorization: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			// // console.log("=====>SSN", SSN);
			// alert(`DOB is ${date_of_birth} and ssn is ${SSN}`);
			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;
			alert(message);
		} else {
			throw error;
		}
	}
};

export const getEOBDetailsWithCheckNumber = async (group_number: number, check_number: number) => {
	try {
		const endpoint = `claims/eob-check-number-v3?group_number=${group_number}&check_number=${check_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			Authorization: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;
			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;
			alert(message);
		} else {
			throw error;
		}
	}
};

export const claimList = {
	getClaimList,
	getClaimListV2,
	getEOBDetails,
	getEOBDetailsV2,
	getClaimStatusDetails,
	getEOBDetailsV3,
	getEOBDetailsWithCheckNumber
};
